(() => {
  const releases = new Map();
  const mobile = matchMedia('(max-width: 767.98px)');
  function header(root) {
    const section = root.closest('.shopify-section');
    if (!section || root.__kh) return;
    root.__kh = true;
    const id = section.id.replace('shopify-section-', '');
    const drawer = section.querySelector('[data-kh-drawer]');
    const burger = root.querySelector('[data-kh-open]');
    const row = root.querySelector('[data-kh-msearch]');
    if (!drawer || !burger) return;
    const syncDrawerStyle = () => {
      const styles = getComputedStyle(root);
      ['--kh-bg', '--kh-ink', '--kh-line', '--kh-soft', '--kh-accent', '--kwf-text', '--kwf-muted', '--kpt-home-font'].forEach(name => {
        const value = styles.getPropertyValue(name).trim();
        if (value) drawer.style.setProperty(name, value);
      });
    };
    syncDrawerStyle();
    document.body.append(drawer);
    const undo = [];
    const listen = (el, event, fn, options) => { if (!el) return; el.addEventListener(event, fn, options); undo.push(() => el.removeEventListener(event, fn, options)); };
    let closeTimer;
    const close = () => {
      drawer.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('kh-menu-open');
      clearTimeout(closeTimer); closeTimer = setTimeout(() => { drawer.hidden = true; }, 300);
      burger.focus();
    };
    listen(burger, 'click', () => {
      clearTimeout(closeTimer); syncDrawerStyle(); drawer.hidden = false;
      document.documentElement.classList.add('kh-menu-open');
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      burger.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
      drawer.querySelector('[data-kh-close]').focus();
    });
    listen(drawer, 'click', event => { if (event.target === drawer || event.target.closest('[data-kh-close]')) close(); });
    listen(document, 'keydown', event => {
      if (drawer.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const nodes = Array.from(drawer.querySelectorAll('a[href],button:not(:disabled),summary,input')).filter(el => el.getClientRects().length);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    listen(root.querySelector('[data-kh-search]'), 'click', () => { row?.querySelector('input[name=q]')?.focus(); row?.scrollIntoView({block:'nearest'}); });
    root.querySelectorAll('.kh__item--drop').forEach(item => {
      const link = item.querySelector('.kh__link');
      const set = open => { item.classList.toggle('is-open',open); link.setAttribute('aria-expanded',String(open)); };
      listen(item,'mouseenter',()=>set(true)); listen(item,'mouseleave',()=>set(false));
      listen(item,'focusin',()=>set(true)); listen(item,'focusout',event=>{if(!item.contains(event.relatedTarget))set(false);});
      listen(item,'keydown',event=>{if(event.key==='Escape'){set(false);link.focus();}});
    });
    const scroll = () => root.classList.toggle('is-scrolled',scrollY>8);
    listen(window,'scroll',scroll,{passive:true}); scroll();
    if (root.classList.contains('kh--sticky')) { section.style.position='sticky';section.style.top='0';section.style.zIndex='40'; }
    if (row) {
      document.querySelectorAll('[data-kh-msearch-for]').forEach(old=>{if(old.dataset.khMsearchFor===id&&old!==row)old.remove();});
      row.dataset.khMsearchFor=id; section.after(row);
    }
    releases.set(section,()=>{undo.forEach(fn=>fn());clearTimeout(closeTimer);row?.remove();if(!drawer.hidden){document.documentElement.style.overflow='';document.documentElement.classList.remove('kh-menu-open');}drawer.remove();});
  }
  function footer(scope) {
    scope.querySelectorAll('.kfoot').forEach(root=>{
      if (root.__kf) return;root.__kf=true;
      const columns=root.querySelectorAll('details.kfoot__col');
      const resize=()=>columns.forEach(el=>{el.open=!mobile.matches;});resize();
      mobile.addEventListener('change',resize);
      const section=root.closest('.shopify-section');
      releases.set(section,()=>mobile.removeEventListener('change',resize));
    });
  }
  function init(scope=document) { scope.querySelectorAll('[data-kh]').forEach(header);footer(scope); }
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{releases.get(event.target)?.();releases.delete(event.target);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();
